import React, { useEffect, useState } from 'react';
import useLocalization from '../../../hooks/useLocalization';

const NetworkStatusBanner = () => {
    const [showBanner, setShowBanner] = useState(false);
    const { t } = useLocalization();

    useEffect(() => {
        const handleOffline = () => {
            setShowBanner(true);

            setTimeout(() => {
                setShowBanner(false);
            }, 2000);
        };

        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    if (!showBanner) return null;

    return (
        <div className="fixed top-0 left-0 w-full text-center text-white py-2 z-50 transition-all duration-300 bg-red-600">
           {t('youAreOffline') || "You are offline. Please check your internet connection."}
        </div>
    );
};

export default NetworkStatusBanner;
